var map = {
	"./en": "3NCY",
	"./en.ts": "3NCY",
	"./en/documentation": "6skC",
	"./en/documentation.ts": "6skC",
	"./en/nav": "Pfhg",
	"./en/nav.ts": "Pfhg",
	"./vo": "oqfC",
	"./vo.ts": "oqfC",
	"./vo/nav": "QhMr",
	"./vo/nav.ts": "QhMr"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YWK9";